import { PageLink } from "../../../../../../_metronic/layout/core"
import { CASHIER_ROLES, DEFAULT_ROLES } from "../../../../../common/core/_consts"
import { ROLE } from "../../../../auth"

const REQUISITE_VIEW_ROLES = [...CASHIER_ROLES, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]

export const REQUISITES_BREADCRUMBS: Array<PageLink> = [
{
    title: 'Доступные для резервирования',
    path: '/settings/requisite/list-enabled',
    isSeparator: false,
    isActive: false,
    roles: REQUISITE_VIEW_ROLES,
  },
  {
    title: 'Недоступные для резервирования',
    path: '/settings/requisite/list-disabled',
    isSeparator: false,
    isActive: false,
    roles: REQUISITE_VIEW_ROLES,
  },
  {
    title: 'Фаст трек',
    path: '/settings/requisite/list-fasttrack',
    isSeparator: false,
    isActive: false,
    roles: REQUISITE_VIEW_ROLES,
  },
  {
    title: 'Типы реквизитов',
    path: '/settings/requisite/types',
    isSeparator: false,
    isActive: false,
    roles: DEFAULT_ROLES,
  },
]